module.exports = __webpack_public_path__ + "static/media/return-arrow-gray.d157bc64.svg";